// Recovered compiled webpack factory 87577. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { q: () => n });
  var a = r(12115);
  function n(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "400px 0px",
      [r, n] = (0, a.useState)(!1);
    return (
      (0, a.useEffect)(() => {
        let r = e.current;
        if (!r) return;
        if ("undefined" == typeof IntersectionObserver) return void n(!0);
        let a = new IntersectionObserver(
          (e) => {
            let [t] = e;
            return n(t.isIntersecting);
          },
          { rootMargin: t },
        );
        return (a.observe(r), () => a.disconnect());
      }, [e, t]),
      r
    );
  }
}
